import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ImageIntroPage} from "./ImageIntroPage";

export class DeadwoodRipIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000, //Default 0x000000
            backgroundAlpha : 0.4, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff

        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xNudge : true,
        xSplit : true,
        xBet : true,
        xRip : true,
        volatility : Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("logo", "resources/images/introLogo.png");
        imgLoader.add("fs", "nolimit/screens/images/FreespinPaytable.png");
        imgLoader.add("superfs", "nolimit/screens/images/SuperFreespin.png");
        imgLoader.add("xNudge", "nolimit/screens/images/xNudge.png");
        imgLoader.add("split", "nolimit/screens/images/wilds.png");
        imgLoader.add("shootout", "nolimit/screens/images/Shootout.png");
        imgLoader.add("quickdraw", "nolimit/screens/images/QuickDraw.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("fs"),
                    scale : 1,
                    position : new PIXI.Point(-180, 0)
                },
                {
                    texture : ImgLoader.getImgTexture("superfs"),
                    scale : 1,
                    position : new PIXI.Point(180, 0)
                }
            ]),
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("xNudge"),
                    scale : 1,
                    position : new PIXI.Point(-180, 0)
                },
                {
                    texture : ImgLoader.getImgTexture("split"),
                    scale : 0.54,
                    position : new PIXI.Point(180, 0)
                }
            ]),
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("shootout"),
                    scale : 0.32,
                    position : new PIXI.Point(-180, 0)
                },
                {
                    texture : ImgLoader.getImgTexture("quickdraw"),
                    scale : 0.54,
                    position : new PIXI.Point(180, 0)
                }
            ]),
        ];
    }
}